import * as React from "react";
const SvgClose = props => <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.8} d="m2 2 10 10m0-10L2 12" /></svg>;
export default SvgClose;